import { isSSR } from 'src/helpers/ssr';
import { isDevelopment } from '../commonUtils';

export function initTargetads(action: string, projectId: number): void {
  try {
    if (isSSR || window.targetAdsDataLayer === undefined) {
      window.targetAdsDataLayer = [];
    } else {
      const dataObject = { eventType: action, params: projectId };

      window.targetAdsDataLayer = [dataObject];
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error in targetAds initialization:', err);
    if (isDevelopment()) {
      // eslint-disable-next-line no-console
      console.error('targetAdsDataLayer initialization failed', err);
    }
  }
}
